import { createSlice } from "@reduxjs/toolkit";

const drawerSlice = createSlice({
  name: "drawer",
  initialState: true,
  reducers: {
    openDrawer: () => true,
    closeDrawer: () => false,
    toggleDrawer: (state) => !state,
  },
});

export const { openDrawer, closeDrawer, toggleDrawer } =
  drawerSlice.actions;

export default drawerSlice.reducer;
